import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export default class InboxApi {
    static fetchInboxConversationsObservable(
        limit: number | undefined = undefined,
        offset: number | undefined = undefined,
        inboxType: any,
        archived?: boolean,
    ) {
        return RESTClient.getAuthenticatedObservable('v2/conversations', {
            limit,
            offset,
            inbox: inboxType,
            inbox2: 1,
            archived,
        });
    }

    static showConversationObservable(
        conversationId,
        limit: number | undefined = undefined,
        suppressErrors: boolean = false,
    ) {
        return RESTClient.getAuthenticatedObservable(
            `v2/conversations/${conversationId}`,
            {limit},
            {
                suppressErrors,
            },
        );
    }

    static showPagedConversationObservable(
        conversationId,
        limit: number | undefined = undefined,
        cursor: number | undefined = undefined,
        suppressErrors: boolean = false,
    ) {
        return RESTClient.getAuthenticatedObservable(
            `v2/conversations/${conversationId}`,
            {limit, cursor},
            {suppressErrors},
        );
    }

    static replyMessageObservable(
        body: string,
        conversationId: string,
        imageIds: string[],
        fileIds: string[],
        sendAsSms: boolean,
    ) {
        return RESTClient.postAuthenticatedObservable('v2/messages', {
            conversationId,
            body,
            imageIds,
            fileIds,
            sendAsSms,
        });
    }

    static sendNewMessageObservable(
        body: string,
        participants: any[],
        imageIds: string[],
        fileIds: string[],
        sendAsSms: boolean,
    ) {
        return RESTClient.postAuthenticatedObservable('v2/messages', {
            body,
            participants,
            imageIds,
            fileIds,
            sendAsSms,
        });
    }

    static getPossibleRecipientsObservable(inboxType) {
        return RESTClient.getAuthenticatedObservable('v2/conversations/participants', {
            inboxType,
        });
    }

    /**
     *
     * @param {*} minimum Represent the minimum amount of messages that tha API should return
     */
    static showAfterMessageIdActionObservable(
        conversationId: string,
        messageId: string,
        minimum: number | undefined = undefined,
        suppressErrors: boolean = false,
    ) {
        return RESTClient.getAuthenticatedObservable(
            `v2/conversations/${conversationId}/afterMessage`,
            {messageId, minimum},
            {suppressErrors},
        );
    }
}
